import { useState, useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import LeadModal from "@/components/LeadModal";

export default function EMI() {
  const [modalOpen, setModalOpen] = useState(false);

  // Strict SPA Mihuru widget — init only on this page, full cleanup on leave
  useEffect(() => {
    const MIHURU_SRC = "https://mihuruendpoint.azureedge.net/dist/js/mihuru-widget-b2c.umd.js";
    const FLAG = "__mihuruActive";
    const INST = "__mihuruWidgetInstance";

    const initWidget = () => {
      if (window[FLAG]) return;
      try {
        if (window.$sw && window.$sw.MihuruWidget) {
          window[FLAG] = true;
          const inst = new window.$sw.MihuruWidget("prod", "INDTA006442");
          inst.initialize();
          window[INST] = inst;
        }
      } catch (e) { console.warn("Mihuru:", e); }
    };

    const existing = document.querySelector('script[data-mihuru="emi"]');
    if (existing && window.$sw) { initWidget(); }
    else if (!existing) {
      const script = document.createElement("script");
      script.src = MIHURU_SRC;
      script.async = true;
      script.setAttribute("data-mihuru", "emi");
      script.onload = initWidget;
      document.head.appendChild(script);
    }

    return () => {
      try { if (window[INST]?.destroy) window[INST].destroy(); } catch {
        /* Intentional: widget may not have initialized — cleanup is best-effort */
      }
      window[FLAG] = false;
      window[INST] = null;
      document.querySelector('script[data-mihuru="emi"]')?.remove();
      document.querySelectorAll('[id*="mihuru"],[class*="mihuru"],[id*="swEmi"],[class*="swEmi"],[data-sw-widget]').forEach(el => {
        if (!el.closest('[data-testid="mihuru-widget-container"]')) el.remove();
      });
      try { delete window.$sw; } catch {
        /* Intentional: window.$sw may not exist — cleanup is best-effort */
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex flex-col" data-testid="emi-page">
      <Navbar onPlanJourney={() => setModalOpen(true)} />

      {/* Clean centered content */}
      <div className="flex-1 flex flex-col items-center justify-center px-6 text-center pt-24 pb-16">
        <div className="max-w-2xl w-full">
          {/* Heading */}
          <p className="overline mb-5">Flexible Travel Financing</p>
          <h1 className="font-heading text-4xl md:text-6xl font-light text-white tracking-tight leading-tight mb-5">
            Don&apos;t Delay Who You&apos;re<br />
            <span className="italic text-[#C9A84C]">Meant to Become</span>
          </h1>
          <p className="text-[#A1A1AA] text-base leading-relaxed mb-3 max-w-lg mx-auto">
            The right journeys shape your perspective, your clarity, your life. Access them when it matters.
          </p>
          <p className="text-[#71717A] text-sm italic mb-12">
            &ldquo;You invest in what shapes you.&rdquo;
          </p>

          {/* Mihuru Widget — centered, primary action */}
          <div data-testid="mihuru-widget-section" className="w-full">
            <p className="text-[10px] uppercase tracking-[0.25em] text-[#C9A84C] mb-5">
              Check Eligibility Instantly
            </p>
            <div
              id="mihuru-widget"
              data-testid="mihuru-widget-container"
              className="w-full min-h-[280px] rounded-2xl overflow-hidden"
            />
            <p className="text-[#71717A] text-xs mt-4 tracking-wider">
              Powered by Mihuru · Instant EMI eligibility · Secure & transparent
            </p>
          </div>
        </div>
      </div>

      <Footer onPlanJourney={() => setModalOpen(true)} />
      <LeadModal isOpen={modalOpen} onClose={() => setModalOpen(false)} source="emi_page" />
    </div>
  );
}
